export default {
    USER_SEARCH: 'USER_SEARCH',
    USER_POSTED: 'USER_POSTED',
    ADMIN_SEARCH: 'ADMIN_SEARCH',
    INTERNAL_JOBS: 'INTERNAL_JOBS',
    MODERATION_JOBS: 'MODERATION_JOBS',
    PROMOTED_JOBS: 'PROMOTED_JOBS',
    LOCATION: 'LOCATION',
    USER_SAVED: 'USER_SAVED',
};
